<template>
    <div class="mass-shell">
        <div class="mass-box" v-for="(item,index) in list" :key="index">
            <div class="mass-header">
                <div class="mass-info">课程信息</div>
                <div class="mass-price">订单金额</div>
                <div class="mass-status">状态</div>
            </div>
            <div class="mass-content"
                 @click="$router.push('/succeed?is_order=1&task_id='+item.task_id + '&member_id='+ item.member_id)">
                <div class="mass-info">
                    <div class="mass-img">
                        <img :src="item.course_info.course_img" alt="">
                    </div>
                    <div class="info">
                        <div class="info-name">{{item.course_info.course_name}}</div>
                        <div class="info-type">类别：食品安全培训</div>
                        <div class="info-num">
                            学时：10课时
                        </div>
                    </div>
                </div>
                <div class="mass-price">
                    ￥{{item.course_info.group_price}}
                </div>
                <div class="mass-status">
                    <div class="tips">
<!--                        0进行中 1 已结束 2 拼团成功 3 拼团失败-->
                        <div class="status" v-if="item.status==0">拼团中</div>
                        <div class="status" v-if="item.status==2">拼团成功</div>
                        <div class="status" v-if="item.status==1 && item.is_success==1|| item.is_success==2">{{item.is_success==1?'拼团成功':'拼团失败,退款成功'}}</div>
                        <div class="time" v-if="item.status==0">剩余时间{{item.last_time}}</div>
                        <div class="warn" v-if="item.status==3">拼团失败,退款成功</div>
                    </div>
                </div>
            </div>
        </div>
        <NoData v-if="list.length<1" width="168px" height="235px"></NoData>
        <div class="paging-shell">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-size="page_size"
                    background layout="prev, pager, next" :total="total"></el-pagination>
        </div>
    </div>
</template>

<script>
  import NoData from '@/components/no-data.vue'

  export default {
    name: 'mass',
    components: {
      NoData
    },
    data () {
      return {
        page_size: 3,
        page: 1,
        total: 0,
        list: [],
        countDown: null
      }
    },
    mounted () {
      this.get_list()
    },
    methods: {
      handleSizeChange (val) { // 每页条数操作
        this.page = 1
        this.get_list()
      },
      handleCurrentChange (val) { // 页数操作
        this.page = val
        this.get_list()
      },
      get_list () {
        let _this = this
        this.API.post('user/group-order_list', {
          page: this.page,
          page_size: this.page_size
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.list = res.data.data
          this.total = res.data.cnt
          if(this.list.length>0){
            this.countDown = setInterval(() => {
              for (let i = 0; i < _this.list.length; i++) {
                _this.list[i].last_time = _this.dif_time(_this.list[i].end_time)
              }
            }, 1000)
          }
        })
      },
      dif_time (endTime) {
        function formatNumber (number) {
          return String(number).padStart(2, '0')
        }

        endTime = new Date(endTime * 1000)
        let startTime = new Date()
        let time_dif = endTime.getTime() - startTime.getTime() // 时间差
        if (time_dif <= 0) {
          return '00:00:00'
        } else {
          // console.log(time_dif)
          //计算出小时数
          let lv1 = time_dif % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
          let h = Math.floor(lv1 / (3600 * 1000))
          //计算相差分钟数
          let lv2 = lv1 % (3600 * 1000)        //计算小时数后剩余的毫秒数
          let m = Math.floor(lv2 / (60 * 1000))
          //计算相差秒数
          let lv3 = lv2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
          let s = Math.round(lv3 / 1000)
          let time = formatNumber(h) + ':' + formatNumber(m) + ':' + formatNumber(s)
          // console.log(d + '天,' + h + '小时,' + m + '分钟,' + s + '秒')
          return time
        }
      },
    }
  }
</script>

<style lang="less" scoped>
    .mass-shell {
        min-height: 50vh;
        padding: 27px 19px;
        background-color: #fff;

        .mass-box {
            .mass-header {
                display: flex;
                align-items: center;
                background-color: #f8f8f8;
                height: 60px;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #000000;;

                .mass-info, .mass-price, .mass-status {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .mass-info {
                width: 50%;
            }

            .mass-price, .mass-status {
                width: 20%;
            }

            .mass-content {
                display: flex;
                height: 170px;
                background-color: #fff;

                .mass-price, .mass-status {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: center;
                }

                .mass-info {
                    display: flex;
                    align-items: center;
                    padding: 0 10px;

                    .mass-img {
                        width: 183px;
                        min-width: 183px;
                        height: 110px;
                        min-height: 110px;
                        margin-right: 10px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }


                    .info-name {
                        font-size: 18px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #000000;
                        width: 200px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        white-space:nowrap;
                        -o-text-overflow: ellipsis; /* for Opera */
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }

                    .info-type, .info-num {
                        width: 100%;
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #999999;
                        margin-top: 5px;
                    }
                }

                .info {
                    display: flex;
                    flex-wrap: wrap;
                }

                .mass-price {
                    font-size: 24px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #EB2020;
                }

                .mass-status {
                    align-items: center;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #2AA9B5;

                    .status {
                        width: 100%;
                        text-align: center;
                    }
                }

                .warn {
                    color: red;
                }

            }
        }
    }
</style>
